"use strict";

import angular from "angular";

angular
    .module("nucont.accounting.company.budget")
    .config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.company.budget", {
            url: "/orcamento?scenarioId&year&source&accountPlanType",
            params: {
                scenarioId: { value: null, dynamic: true },
                year: { value: null, dynamic: true },
                source: { value: null, dynamic: true },
                accountPlanType: { value: null, dynamic: true }
            },
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-company-budget" */ "./budget.entry"
                ).then(() =>
                    $ocLazyLoad.inject("nucont.accounting.company.budget")
                );
            },
            views: {
                "admin@nucont.accounting": {
                    component: "budgetViewComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            bodyClass: "budget-module"
        })
        .state("nucont.accounting.company.budget.accounting", {
            url: "/contabil",
            views: {
                "budget@nucont.accounting.company.budget": {
                    component: "budgetAccountingViewComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            params: {
                source: { value: "accounting" }
            },
            bodyClass: "budget-module"
        })
        .state("nucont.accounting.company.budget.fin", {
            url: "/financeiro",
            views: {
                "budget@nucont.accounting.company.budget": {
                    component: "budgetFinancialViewComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            params: {
                source: { value: "fin" }
            },
            bodyClass: "budget-module"
        })
        .state("nucont.accounting.company.budget.tax", {
            url: "/fiscal",
            views: {
                "budget@nucont.accounting.company.budget": {
                    component: "budgetTaxViewComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            params: {
                source: { value: "tax" }
            },
            bodyClass: "budget-module"
        })
        .state("nucont.accounting.company.budget.personnel", {
            url: "/pessoal",
            views: {
                "budget@nucont.accounting.company.budget": {
                    component: "budgetPersonnelViewComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            params: {
                source: { value: "personnel" }
            },
            bodyClass: "budget-module"
        });
}
